import { AbstractControl, ValidationErrors } from '@angular/forms';

export function smartNameValidator(
  forbiddenSymbols: RegExp = /[\{\}\[\]\*@#\$%&\(\)]/
): (control: AbstractControl) => ValidationErrors | null {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    // 1. Validar tipo
    if (typeof value !== 'string') return { invalidType: true };

    const trimmed = value.trim();

    // 2. No permitir vacío o solo espacios
    if (!trimmed) return { empty: true };

    // 3. IMPORTANTE: Debe contener al menos una letra o número
    const hasAlphanumeric = /[A-Za-z0-9À-ÿ\u00f1\u00d1]/.test(trimmed);
    if (!hasAlphanumeric) {
      return { onlySymbols: true };
    }

    // 4. Bloquear símbolos completamente prohibidos: * @ # $ % & ( ) { } [ ]
    if (forbiddenSymbols.test(trimmed)) {
      return { forbiddenSymbols: true };
    }

    // 5. Detectar repeticiones excesivas del mismo símbolo (3 o más veces seguidas)
    const hasRepeatedSymbols = /([^\w\sÀ-ÿ])\1{2,}/.test(trimmed);
    if (hasRepeatedSymbols) {
      return { repeatedSymbols: true };
    }

    return null;
  };
}

/**
 * Validador para persona física que no permite espacios en blanco, números ni caracteres especiales
 * Solo permite letras (incluyendo acentos y ñ)
 * Bloquea específicamente: espacios, números, #$%&( y otros caracteres especiales
 */
export function naturalPersonNameValidator(
  control: AbstractControl
): ValidationErrors | null {
  const value = control.value;

  // Si el valor está vacío, no validar (dejar que otros validadores como required lo manejen)
  if (!value || value === '') {
    return null;
  }

  // Validar tipo
  if (typeof value !== 'string') {
    return { invalidType: true };
  }

  // No permitir espacios en blanco
  // if (/\s/.test(value)) {
  //   return { noSpacesAllowed: true };
  // }

  // Caracteres específicos prohibidos: #$%&(
  const forbiddenChars = /[#$%&(]/;
  if (forbiddenChars.test(value)) {
    return { forbiddenCharacters: true };
  }

  // No permitir números
  if (/[0-9]/.test(value)) {
    return { noNumbersAllowed: true };
  }

  // Solo permitir letras (incluyendo acentos y ñ)
  // No permitir números ni ningún carácter especial
  const onlyLettersAndSpaces = /^[A-Za-zÀ-ÿ\u00f1\u00d1 ]+$/.test(value);
  if (!onlyLettersAndSpaces) {
    return { noSpecialCharactersAllowed: true };
  }

  return null;
}
